import React from 'react';
import PropTypes from 'prop-types';
import { withFormik } from 'formik';
import Yup from 'yup';
import EmailInput from '../../Global/Forms/EmailInput';
import RadioInput from '../../Global/Forms/RadioInput';
import ModalHeader from '../../Global/Modals/ModalHeader';
import ModalFooter from '../../Global/Modals/ModalFooter';
import ModalBody from '../../Global/Modals/ModalBody';
import ModalPadding from '../../Global/Modals/ModalPadding';
import Button from '../../Global/Buttons/Button';
import Form from "../../Global/Forms/Form";

const AllocateLicenceForm = ({
  // Props from parent component
  onCloseClick,
  loading,
  // Formik props
  values,
  errors,
  touched,
  handleChange,
}) => (
  // Unfortunately have to add the flex classes here to allow vertical scrolling as in this version of React there needs to be a containing div
  <Form className="allocate-licence-form d-flex flex-column">
    <ModalHeader title="Allocate licence" onCloseClick={onCloseClick} />

    <ModalBody>
      <ModalPadding>
        <p>Please enter the email address of the person you would like to allocate a licence to. This person must already be a member of The Coaching Manual.</p>

        <EmailInput
          name="emailAddress"
          label="Email address"
          value={values.emailAddress}
          onChange={handleChange}
          error={errors.emailAddress}
          touched={touched.emailAddress}
          required
        />

        <div className="form-group form-inline">
          <span className="faux-label">Licence type *</span>

          <div className="form-inline__field-container">
            <RadioInput
              name="licenceType"
              label="Standard"
              onChange={handleChange}
              value="standard"
              checked={values.licenceType === `standard`}
            />

            <RadioInput
              name="licenceType"
              label="Premium"
              onChange={handleChange}
              value="premium"
              checked={values.licenceType === `premium`}
            />
          </div>
        </div>
      </ModalPadding>
    </ModalBody>

    <ModalFooter>
      <Button type="submit" loading={loading}>Submit</Button>
    </ModalFooter>
  </Form>
);

AllocateLicenceForm.propTypes = {
  onCloseClick: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  // Formik
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
};

const FormikAllocateLicenceForm = withFormik({
  mapPropsToValues(props) {
    return {
      emailAddress: ``,
      licenceType: props.licenceType || `premium`,
    };
  },
  validationSchema: Yup.object().shape({
    emailAddress: Yup.string()
      .label(`Email address`)
      .email()
      .matches(/^[A-Za-z0-9.+_-]+@[A-Za-z0-9._-]+\.[a-zA-Z]*$/, `Must not contain international characters`)
      .required(),
  }),
  handleSubmit(values, bag) {
    bag.props.onSubmit(values);
  },
})(AllocateLicenceForm);

export default FormikAllocateLicenceForm;



// WEBPACK FOOTER //
// ./library/app/components/Account/LicenceManager/AllocateLicenceForm.js